module.exports = __webpack_public_path__ + "static/RahyussalimMDPhD-e969e4a25bf96d2eb7402886acd7e67e.jpg";